import '@cloudscape-design/global-styles/index.css';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { useContext, useEffect, useRef } from 'react';
import { RumContext } from './components/rum-provider';
import Home from './pages/HomePage';
import Demos from './pages/Demos';
import { useAuth } from "react-oidc-context";
import { Alert, Button, Container, Header, SpaceBetween, StatusIndicator } from '@cloudscape-design/components';
import { Divider } from '@mui/material';
import AdminDashboard from './pages/admin/Dashboard';
import DemoDetailsPage from './pages/DemoDetailsPage';
import AdminDemoDetails from './pages/admin/DemoDetails';
import AddDemo from './pages/admin/AddDemo';
import EditDemo from './pages/admin/EditDemo';
import AddAsset from './pages/admin/AddAsset';
import AssetDetails from './pages/admin/AssetDetails';
import FAQPage from './pages/FAQPage';
import ManageFAQs from './pages/admin/ManageFAQs';
import AddFAQ from './pages/admin/AddFAQ';
import SFDCTagging from './pages/SFDCTagging';


export default function App() {
  const auth = useAuth();
  // const rum = useContext(RumContext);
  if (auth.isLoading) {
    return (
      <SpaceBetween direction='vertical' size='m' alignItems='center'>
        <Container>
          <SpaceBetween direction='vertical' size='m' alignItems='center'>
            <Header variant='awsui-h1-sticky'>EdTech Demo Portal</Header>
            <StatusIndicator type='loading'>Please wait...</StatusIndicator>
          </SpaceBetween>
        </Container>
      </SpaceBetween>
    )
  }
  if (auth.error) {
    return (
      <SpaceBetween direction='vertical' size='m' alignItems='center'>
        <Container>
          <SpaceBetween direction='vertical' size='m' alignItems='center'>
            <Header variant='awsui-h1-sticky'>EdTech Demo Portal</Header>
            <Header variant='h2'>Please sign in with Midway to continue</Header>
            <Button onClick={() => auth.signinRedirect({
              url_state: encodeURIComponent(window.location.pathname)
            })}>Sign in with Midway</Button>
            <Divider />
            <Alert type='error'
              header="An error occurred">{auth.error.message}</Alert>
          </SpaceBetween>
        </Container>
      </SpaceBetween>

    )
  }
  // Create a wrapper component to handle route changes
  const RouteTracker = () => {
    const location = useLocation();
    const rum = useContext(RumContext);
    const isFirstLoad = useRef(true);

    useEffect(() => {
      if (!rum || !auth.isAuthenticated || !isFirstLoad.current) return; // ADDED auth.isAuthenticated check
      // Ensure RUM is initialized before recording page view
      if (rum) {
        console.log('Recording page view:', location.pathname);
        rum.recordPageView(location.pathname);
        isFirstLoad.current = false;
      }
    }, [location.pathname, rum]); // ADDED auth.isAuthenticated to the dependency array

    return null;
  };

  if (auth.isAuthenticated) {
    if (auth.user?.url_state) {
      window.location.href = decodeURIComponent(auth.user?.url_state as string);
    }

    return (
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="details/:path" element={<DemoDetailsPage />} />
          <Route path="demo/:path" element={<Demos />} />
          <Route path="/sfdc-tagging" element={<SFDCTagging />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/demo" element={<AddDemo />} />
          <Route path="/admin/demo/:path" element={<AdminDemoDetails />} />
          <Route path="/admin/demo/:path/edit" element={<EditDemo />} />
          <Route path="/admin/asset" element={<AddAsset />} />
          <Route path="/admin/asset/:path" element={<AssetDetails />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/admin/faq" element={<ManageFAQs />} />
          <Route path="/admin/faq/new" element={<AddFAQ />} />
        </Routes>
      </BrowserRouter>
    );
  }
  return (
    <SpaceBetween direction='vertical' size='m' alignItems='center'>
      <Container>
        <SpaceBetween direction='vertical' size='m' alignItems='center'>
          <Header variant='awsui-h1-sticky'>EdTech Demo Portal</Header>
          <Header variant='h2'>Please sign in with Midway to continue</Header>
          <Button onClick={() => auth.signinRedirect({
            url_state: encodeURIComponent(window.location.pathname)
          })}>Sign in with Midway</Button>
        </SpaceBetween>
      </Container>
    </SpaceBetween>
  )

}

